import React, { useEffect, useRef, useState } from "react"
import { useSubheader } from "../../../../../_metronic/layout"
import * as Yup from "yup"
import {
  FORM_NEED,
  getStringErrorMassage
} from "../../../../helpers/StringCollection.js"
import { TabsInputComponent } from "../../../../../component"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers"
import { useDispatch, useSelector } from "react-redux"
import { CreateEditForm } from "./Form/CreateEditForm"
import {
  createTeamDrone,
  GetDetailHeaderTeamDrone
} from "../../../../../redux/actions/FieldOfficerAction"
import swal from "sweetalert"
import { PopupQuestion } from "../../../../../component/atoms/Popup"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants"
import { RoutesConstants } from "../../../../../constants/RoutesConstants"
import { FIELD_OFFICER_ROLE_ENUM } from "../../../../../constants/StringConstant"
import { useTranslation } from "react-i18next"
import { stringFormatting } from "../../../../helpers/TextHelper.js"
import { loadUserLogin } from "../../../../../config/index.jsx"

export const CreateEditTeamDrone = ({
  history,
  match: {
    params: { action, id }
  }
}) => {
  const subHeader = useSubheader()
  const { t } = useTranslation()
  const [isValid, setIsValid] = useState(false)
  const formRef = useRef()
  const dispatch = useDispatch()
  const { General, FieldOfficer, MasterData } = useSelector((state) => state)
  const [isPreview, setIsPreview] = useState(false)
  const [initialValue, setInitialValue] = useState({
    regionalId: "",
    subRegionalId: "",
    baseId: "",
    regencyIds: [],
    member_list_1: "",
    member_list_2: "",
    description: "",
    useAvaliableWarehouse: null,
    warehouseId: ""
  })
  const stepsTitle = [null]
  const stepsDescription = [null]
  const [swalMessage, setSwalMessage] = useState("")
  const [swalIcon, setSwallIcon] = useState("")
  const [showModalDialog, setShowModalDialog] = useState(false)
  const [showModalDialogCancel, setShowModalDialogCancel] = useState(false)
  const userLogin = loadUserLogin()

  useEffect(() => {
    if (id) {
      dispatch(GetDetailHeaderTeamDrone(id))
    }
  }, [id])

  useEffect(() => {
    if (FieldOfficer?.detail?.id) {
      let memberList = FieldOfficer?.detail?.member_list.map((value) => value.id)
      setInitialValue({
        regionalId: FieldOfficer?.detail?.regional_id ? FieldOfficer?.detail?.regional_id : (userLogin?.regional_id !== null && userLogin?.regional_id !== "") ? userLogin?.regional_id : "",
        subRegionalId: FieldOfficer?.detail?.sub_regional_id || "",
        baseId: FieldOfficer?.detail?.base_id || "",
        regencyIds: FieldOfficer?.detail?.regency_list?.map((r) => r.id) || [],
        member_list_1: memberList[0] || "",
        member_list_2: memberList[1] || "",
        description: FieldOfficer?.detail?.description || "",
        useAvaliableWarehouse: (FieldOfficer?.detail?.warehouse_id !== null && FieldOfficer?.detail?.warehouse_id !== "") ? "true" : null,
        warehouseId: FieldOfficer?.detail?.warehouse_id || ""
      })
    } else {
      setInitialValue({
        regionalId: userLogin?.regional_id !== null && userLogin?.regional_id !== "" ? userLogin?.regional_id : "",
        subRegionalId: "",
        baseId: "",
        regencyIds: [],
        member_list_1: "",
        member_list_2: "",
        description: "",
        useAvaliableWarehouse: null,
        warehouseId: ""
      })
    }
  }, [FieldOfficer.detail])


  const buttonSubmited = (
    <button
      type="button"
      disabled={!isValid}
      className="btn btn-primary"
      onClick={() => {
        if (isPreview) {
          setShowModalDialog(true)
        } else {
          setIsPreview(true)
        }
      }}>
      {isPreview ? t("label_create_team") : t("button_furthermore")}
    </button>
  )

  const buttonCancel = (
    <button
      type="button"
      className="btn btn-secondary-info mr-4"
      onClick={() => {
        if (isPreview) {
          setIsPreview(false)
        } else {
          setShowModalDialogCancel(true)
        }
      }}>
      {t("button_previous_kembali")}
    </button>
  )

  const createEditFlow = [
    <CreateEditForm
      key={0}
      isReadOnly={false}
      id={id}
      isPreview={isPreview}
      btnSubmit={buttonSubmited}
      btnCancel={buttonCancel}
    />
  ]

  const ValidationScheme = [
    Yup.object().shape({
      regionalId: Yup.string().transform((value) => value || "").nullable(false).required(
            getStringErrorMassage("Regional ", FORM_NEED.harusDiIsi)
          ),
      subRegionalId: Yup.string().transform((value) => value || "").nullable(false).required(
            getStringErrorMassage("Sub Regional ", FORM_NEED.harusDiIsi)
          ),
      baseId: Yup.string().transform((value) => value || "").nullable(false).required(
            getStringErrorMassage("Base ", FORM_NEED.harusDiIsi)
          ),
      useAvaliableWarehouse: Yup.string().required(
        getStringErrorMassage("Use Avaliable Warehouse ", FORM_NEED.harusDiIsi)
      ),
      warehouseId: Yup.string().when("useAvaliableWarehouse", {
        is: "true",
        then: Yup.string().required(
          getStringErrorMassage("Warehouse ", FORM_NEED.harusDiIsi)
        ),
        otherwise: Yup.string()
      }),
      member_list_1: Yup.string().required(
        getStringErrorMassage("Member List 1 ", FORM_NEED.harusDiIsi)
      ),
      member_list_2: Yup.string().transform((value) => value || "").nullable(true)
    })
  ]

  useEffect(() => {
    subHeader.setButton(buttonSubmited)
    subHeader.setButton(null)
    if (isPreview) {
      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER),
          title: t("breadcrumb_fo")
        },
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("list-fo"),
          title: t("breadcrumb_fo_agronomist")
        },
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("team-drone"),
          title: t("breadcrumb_drone_pilot")
        },
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("team-drone"),
          title: action === "new" ? t("breadcrumb_add_team") : t("breadcrumb_edit_team")
        },
        {
          title: t("breadcrumb_preview")
        }
      ])
    } else {
      subHeader.setBreadcrumbs([
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER),
          title: t("breadcrumb_fo")
        },
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("list-fo"),
          title: t("breadcrumb_fo_agronomist")
        },
        {
          pathname: RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("team-drone"),
          title: t("breadcrumb_drone_pilot")
        },
        {
          title: action === "new" ? t("breadcrumb_add_team") : t("breadcrumb_edit_team")
        }
      ])
    }
  }, [isPreview])

  function onSubmitForm(e) {
    const { values, submited } = e
    setSwalMessage(
      id
        ? t("messages_response_team_drone_change_success")
        : t("messages_response_team_drone_add_success")
    )
    setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_ILLUSTRATION))

    if (submited) {
      const formData = {
        member_list: values?.member_list_2
          ? [values?.member_list_1, values?.member_list_2]
          : [values?.member_list_1],
        description: values?.description,
        base_id: values?.baseId,
        regency_ids: values?.regencyIds?.length > 0 ? values.regencyIds : null,
        use_available_warehouse: values?.useAvaliableWarehouse === "true",
        warehouse_id: values?.useAvaliableWarehouse === "true" ? values?.warehouseId : null
      }
      setShowModalDialog(false)
      if (id) {
        dispatch(createTeamDrone(formData, id))
      } else {
        dispatch(createTeamDrone(formData))
      }
    }
  }

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (swalMessage) {
        swal({
          icon: swalIcon,
          text: swalMessage
        })
      }
      setShowModalDialog(false)
      history.push(RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("team-drone"))
    }
  }, [General.isFinishUpdateOrDelete])

  return (
    <>
      <PopupQuestion
        disable={!isValid}
        onCancel={() => setShowModalDialog(false)}
        textCancel={t("button_batal")}
        textOk={t("button_next")}
        title={action === "new" ? t("modal_title_add_team") : t("modal_title_edit_team")}
        onOk={() => formRef.current.handleSubmit()}
        show={showModalDialog}
        bodyCustom={
          <RowModule>
            {id ? <div className="d-flex flex-column align-items-center justify-content-center">
              <div className="text-center text-neutral-black txt-14">
                {t("messages_confirmation_edit_drone_team")}
              </div>
              <div className="text-center text-neutral-black txt-14">
                {t("messages_confirmation_edit_drone_team_second_line")}
              </div>
            </div> : <div className={"d-flex flex-column align-items-center justify-content-center gap-8"}>
              <p className="text-center text-neutral-black txt-14">
                {t("messages_confirmation_add_drone_team")}
              </p>
              <span className="txt-14">{t("label_warehouse_id_mobile_odoo")} : <span className="font-weight-bolder txt-14">{formRef?.current?.values?.useAvaliableWarehouse === "true" ? stringFormatting(MasterData?.listWarehouseAvailable?.find((item) => item.id === formRef?.current?.values?.warehouseId)?.name) : t("label_create_new_odoo_warehouse")}</span></span>
            </div>}
          </RowModule>
        }
      />
      <PopupQuestion
        onCancel={() => setShowModalDialogCancel(false)}
        textCancel={t("button_batal")}
        textOk={t("button_next")}
        title={action === "new" ? t("modal_title_cancel_add_team") : t("modal_title_cancel_edit_team")}
        onOk={() => history.push(RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("team-drone"))}
        show={showModalDialogCancel}
        bodyCustom={
          <RowModule>
            <p className={"swal-text p-4"}>
              {id
                ? t("messages_confirmation_team_edit_cancel")
                : t("messages_confirmation_team_create_cancel")}
            </p>
          </RowModule>
        }
      />
      <TabsInputComponent
        validateOnMount={true}
        onValidationChange={(valid) => setIsValid(valid)}
        isEditTabs={false}
        steps={stepsTitle}
        stepDescription={stepsDescription}
        formInitialValues={initialValue}
        formId="createTim"
        innerRef={formRef}
        componentTab={createEditFlow}
        validationSchema={ValidationScheme}
        onSubmitForm={onSubmitForm}
      />
    </>
  )
}
